import React from "react";
import { FaCreditCard, FaMoneyBillWave } from "react-icons/fa";

const PaymentOptions = ({ isOpen, onClose, onSelectPayment, total }) => {
  if (!isOpen) return null;

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const openRazorpay = async () => {
    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const options = {
      key: "rzp_test_gW8KHeBaMm089M",
      amount: Math.round(total * 100),
      currency: "INR",
      name: "BrickNBar",
      description: "Order Payment",
      handler: function (response) {
        // After successful payment, select Razorpay as payment method
        // and include the payment ID from Razorpay
        onSelectPayment("Razorpay", response.razorpay_payment_id);
        onClose();
      },
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  const handleSelectPayment = (method) => {
    if (method === "COD") {
      onSelectPayment("COD");
      onClose();
    } else if (method === "Razorpay") {
      openRazorpay();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Select Payment Method</h2>

        <div className="space-y-4">
          <div
            className="border border-gray-300 rounded-lg p-4 cursor-pointer hover:bg-gray-50 flex items-center"
            onClick={() => handleSelectPayment("COD")}
          >
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <FaMoneyBillWave className="text-green-600" size={20} />
            </div>
            <div>
              <h3 className="font-semibold">Cash On Delivery</h3>
              <p className="text-sm text-gray-600">
                Pay when you receive your order
              </p>
            </div>
          </div>

          <div
            className="border border-gray-300 rounded-lg p-4 cursor-pointer hover:bg-gray-50 flex items-center"
            onClick={() => handleSelectPayment("Razorpay")}
          >
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <FaCreditCard className="text-blue-600" size={20} />
            </div>
            <div>
              <h3 className="font-semibold">Pay Now</h3>
              <p className="text-sm text-gray-600">
                Pay securely with credit/debit card or UPI
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentOptions;
